export const ASHLEY_PHASE = Object.freeze({
  IDLE: "idle",
  PROMPTING: "prompting",
  SPEAKING: "speaking",
  LISTENING: "listening",
  ROUTING: "routing",
  CLOSING: "closing",
});

export const VOICE_INTENT_CATEGORY = Object.freeze({
  NAVIGATION: "navigation",
  WORKFLOW: "workflow",
  ACTION: "action",
});

export const VOICE_WORKFLOW = Object.freeze({
  OPEN_MATERIALS_PICKER: "open_materials_picker",
  OPEN_START_SESSION: "open_start_session",
  OPEN_STOP_SESSION: "open_stop_session",
  CREATE_PROJECT_MVP: "create_project_mvp",
  START_SESSION_MVP: "start_session_mvp",
});
